// @spec GHG-STR-065
'use client';

import { useOrganization } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

import { Skeleton } from '@/components/ui/skeleton';
import { useGHGOrganizationId } from '@/features/ghg/api/use-ghg-organization-id';
import { ISO14064ComplianceCheck } from '@/features/ghg/components/ISO14064ComplianceCheck';
import { useGHGPagePeriod } from '@/features/ghg/hooks/use-ghg-page-period';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/iso14064-compliance')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.iso14064Compliance'),
  }),
  component: ISO14064CompliancePage,
});

function ISO14064CompliancePage() {
  const { isLoaded: isOrgLoaded } = useOrganization();
  const orgId = useGHGOrganizationId();
  const { periodId, period } = useGHGPagePeriod();
  const selectedYear = period
    ? new Date(period.startDate).getUTCFullYear()
    : undefined;

  if (!isOrgLoaded || !orgId) {
    return (
      <div className="p-8">
        <div className="mx-auto max-w-7xl space-y-6">
          <Skeleton className="h-9 w-64" />
          <Skeleton className="h-5 w-96" />
          <Skeleton className="h-96 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-3xl font-semibold text-foreground">ISO 14064 Compliance Check</h1>
            <p className="mt-1 text-muted-foreground">
              Automated validation against ISO 14064-1:2018 requirements
            </p>
          </div>
        </header>

        <ISO14064ComplianceCheck
          key={periodId}
          organizationId={orgId}
          year={selectedYear}
        />
      </div>
    </div>
  );
}
